import { EOrderStatus } from '@mahawi/eshop-common/src/types';
import React from 'react';

import OrderLayout from '../../components/orders/orders-layout';

function OrdersRefundedContainer(): React.ReactElement {
  return <OrderLayout orderStatusTypeCodes={[EOrderStatus.REFUNDED]} />;
}

export default OrdersRefundedContainer;
